import React from 'react'
import { Modal, App } from 'antd'
import { useFinanceSubTypeDelMutation,} from '../../store/ReactWebSiteApi';

function BalanceTypeDel(props) {
    const { message } = App.useApp();
    const {confirm} = Modal; 
    const [submitDel] = useFinanceSubTypeDelMutation()
    return (
        <>
            {props.efst_state==='2'&& <a onClick={() => {
                confirm({
                    title: '确定删除？',
                    content: props.efst_name,
                    okText: '确认',
                    okType: 'danger',
                    cancelText: '取消',
                    onOk() {
                        submitDel({
                                efst_id:props.efst_id,
                                efst_state:'2',
                            }).then((res) => {
                            // console.log(res);
                            if (res.data.Status === 'success') {
                                message.info('删除成功！');
                            }
                            if (res.data.Status === "fail") {
                                message.error('删除失败！'+res.data.Message)
                            }
                        })
                    },
                    onCancel() {
                        // console.log('Cancel');
                    },
                }); 
            }}>删除</a>}
            {props.efst_state==='1'&&<a onClick={() => {
                                        confirm({
                                            title: '确定取消删除？',
                                            content: props.efst_name,
                                            okText: '确认',
                                            okType: 'danger',
                                            cancelText: '取消',
                                            onOk() {
                                                submitDel({
                                                    efst_id:props.efst_id,
                                                    efst_state:'1'
                                                }).then((res) => {
                                                    if (res.data.Status === 'success') {
                                                        message.info('取消删除成功！');
                                                    }
                                                    if (res.data.Status === "fail") {
                                                        message.error('取消删除失败！'+res.data.Message)
                                                    }
                                                })
                                            },
                                            onCancel() {
                                            // console.log('Cancel');
                                            },
                                        });
                                    }}>取消删除</a>}
        </>
    )
}

export default BalanceTypeDel